module.exports = __webpack_public_path__ + "images/emoji/flashlight.26d9f1e673e1cfc44c0d.png";